var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusinessNetworking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 120,
    viewBox: "0 0 112 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8146 10.7383C14.1365 10.7383 14.3975 10.4773 14.3975 10.1554C14.3975 9.83348 14.1365 9.57251 13.8146 9.57251C13.4927 9.57251 13.2317 9.83348 13.2317 10.1554C13.2317 10.4773 13.4927 10.7383 13.8146 10.7383Z",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9884 63.4549C55.3104 63.4549 55.5713 63.1939 55.5713 62.872C55.5713 62.55 55.3104 62.2891 54.9884 62.2891C54.6665 62.2891 54.4055 62.55 54.4055 62.872C54.4055 63.1939 54.6665 63.4549 54.9884 63.4549Z",
    stroke: "#5672B6",
    strokeWidth: 3.536,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5986 10.1555C37.2425 10.1555 37.7645 9.63349 37.7645 8.9896C37.7645 8.34571 37.2425 7.82373 36.5986 7.82373C35.9547 7.82373 35.4327 8.34571 35.4327 8.9896C35.4327 9.63349 35.9547 10.1555 36.5986 10.1555Z",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7477 29.4826C2.45013 29.4826 3.01957 28.9131 3.01957 28.2107C3.01957 27.5083 2.45013 26.9388 1.7477 26.9388C1.04526 26.9388 0.47583 27.5083 0.47583 28.2107C0.47583 28.9131 1.04526 29.4826 1.7477 29.4826Z",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3942 68.2031C91.5067 67.5098 91.0359 66.8564 90.3425 66.7439C89.6492 66.6314 88.9959 67.1022 88.8833 67.7956C88.7708 68.4889 89.2416 69.1423 89.935 69.2548C90.6284 69.3673 91.2817 68.8965 91.3942 68.2031Z",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3599 22.7968L98.5247 21.9617",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2783 20.7153L96.493 19.9299",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3281 21.9617L96.493 22.7968",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3599 19.9299L98.5247 20.7652",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7135 4.30597L57.8783 3.47083",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.632 2.22435L55.8466 1.43896",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6819 3.47083L55.8466 4.30597",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7135 1.43896L57.8783 2.27419",
    stroke: "#5672B6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 70.0807L12.175 69.2456",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9285 67.9991L10.1431 67.2137",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9784 69.2456L10.1431 70.0807",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 67.2137L12.175 68.049",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.656 36.2562C110.978 36.2562 111.239 35.9953 111.239 35.6733C111.239 35.3514 110.978 35.0905 110.656 35.0905C110.334 35.0905 110.073 35.3514 110.073 35.6733C110.073 35.9953 110.334 36.2562 110.656 36.2562Z",
    stroke: "#5672B6",
    strokeWidth: 0.54,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4787 5.91872C78.8006 5.91872 79.0616 5.65775 79.0616 5.33582C79.0616 5.0139 78.8006 4.75293 78.4787 4.75293C78.1568 4.75293 77.8958 5.0139 77.8958 5.33582C77.8958 5.65775 78.1568 5.91872 78.4787 5.91872Z",
    stroke: "#5672B6",
    strokeWidth: 3.536,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9507 58.7971H10.3042C9.49056 58.7971 8.83099 58.1376 8.83099 57.324V16.2476C8.83099 15.434 9.49056 14.7744 10.3042 14.7744H87.9507C88.7643 14.7744 89.4239 15.434 89.4239 16.2476V57.324C89.4239 58.1376 88.7643 58.7971 87.9507 58.7971Z",
    fill: "#E3E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1274 36.7856H8.83093V16.6722C8.83093 15.4362 9.83292 14.4343 11.0688 14.4343H49.1274V36.7856ZM87.1859 58.6585H49.1274V36.8257H89.4238V56.4205C89.4239 57.6565 88.4219 58.6585 87.1859 58.6585Z",
    fill: "#F0F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9513 59.0571H10.3048C9.15799 59.0571 8.22504 58.124 8.22504 56.9773V15.9008C8.22504 14.7541 9.15807 13.821 10.3048 13.821H87.9513C89.0982 13.821 90.0311 14.7541 90.0311 15.9008V56.9772C90.0311 58.124 89.0981 59.0571 87.9513 59.0571ZM10.3048 15.0343C9.827 15.0343 9.43825 15.423 9.43825 15.9008V56.9772C9.43825 57.455 9.827 57.8438 10.3048 57.8438H87.9513C88.4292 57.8438 88.8179 57.455 88.8179 56.9772V15.9008C88.8179 15.423 88.4292 15.0343 87.9513 15.0343H10.3048Z",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9507 59.0571V57.8439C88.4285 57.8439 88.8173 57.4551 88.8173 56.9773H90.0305C90.0305 58.124 89.0975 59.0571 87.9507 59.0571ZM90.0305 15.9008H88.8173C88.8173 15.423 88.4285 15.0343 87.9507 15.0343V13.821C89.0975 13.821 90.0305 14.7541 90.0305 15.9008ZM9.43752 15.9008H8.2243C8.2243 14.7541 9.15734 13.821 10.3041 13.821V15.0343C9.82635 15.0343 9.43752 15.423 9.43752 15.9008ZM10.3042 59.0571C9.15734 59.0571 8.22438 58.124 8.22438 56.9773H9.43759C9.43759 57.4551 9.82635 57.8439 10.3042 57.8439V59.0571Z",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 32.1627H13.0539",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4024 32.1627H42.0181",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1926 32.1627H42.2363",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 27.7723H13.0539",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4024 27.7723H42.0181",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1926 27.7723H42.2363",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 23.382H13.0539",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4024 23.382H42.0181",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1926 23.382H42.2363",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 18.9916H13.0539",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4024 18.9916H42.0181",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1926 18.9916H42.2363",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.625 17.4855V19.7149L40.8844 18.9743L32.8391 27.0515L31.0103 25.2226L25.0536 31.1792L22.0649 28.1904L15.0149 35.2101H13.3869L22.0649 26.5664L25.0536 29.5551L31.0103 23.5986L32.8391 25.4274L40.0722 18.1624L39.3956 17.4855H41.625Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1621 35.2101H13.0101V16.8829",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1621 35.7612V34.6592L43.7131 35.2102L43.1621 35.7612Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5611 16.8829H12.4591L13.0101 16.332L13.5611 16.8829Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1002 53.3583H53.1439",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4926 53.3583H82.1082",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2826 53.3583H82.3264",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1002 48.9679H53.1439",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4926 48.9679H82.1082",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2826 48.9679H82.3264",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1002 44.5774H53.1439",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4926 44.5774H82.1082",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2826 44.5774H82.3264",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1002 40.187H53.1439",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4926 40.187H82.1082",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.12 4.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2826 40.187H82.3264",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2522 56.5356H52.9702V38.0785H53.2302V56.2757H83.2522V56.5356Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2522 56.9565V55.8546L83.8032 56.4056L83.2522 56.9565Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6511 38.0785H52.5492L53.1002 37.5275L53.6511 38.0785Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.519 40.7231L80.3112 39.9722L79.5602 40.18L79.9194 40.3835L74.2043 50.7018L66.0832 45.861L61.7208 50.9756L58.0566 48.6229L52.9916 56.3343L53.2089 56.477L58.1326 48.9808L61.7712 51.317L66.1385 46.1966L74.3016 51.0625L80.1457 40.5116L80.519 40.7231Z",
    fill: "#4C4D51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.023 39.7956L83.0218 39.0164L82.2426 39.0175L82.5405 39.3145L73.2901 48.5328L63.227 45.8801L58.4209 52.7001H53.1002V52.96H58.5558L63.3355 46.1775L73.2958 48.8032L73.368 48.8222L82.7245 39.4981L82.7133 39.4869L83.023 39.7956Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 32.4371H86.7516",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.11 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3607 28.7458H53.1492C52.9099 28.7458 52.7159 28.9398 52.7159 29.1791V35.2101H56.794V29.1791C56.794 28.9398 56.6 28.7458 56.3607 28.7458Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 28.7458H86.7516",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.11 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 25.0547H86.7516",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.11 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 21.3634H86.7516",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.11 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 17.6722H86.7516",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.11 4.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3517 26.1461H60.1402C59.9009 26.1461 59.7069 26.3401 59.7069 26.5794V35.2102H63.785V26.5794C63.785 26.3401 63.591 26.1461 63.3517 26.1461ZM70.3427 24.4129H67.1312C66.8919 24.4129 66.6979 24.6069 66.6979 24.8462V35.2102H70.7759V24.8462C70.7759 24.6069 70.582 24.4129 70.3427 24.4129ZM77.3336 21.8132H74.1221C73.8828 21.8132 73.6889 22.0072 73.6889 22.2465V35.2102H77.7669V22.2465C77.7669 22.0072 77.5729 21.8132 77.3336 21.8132ZM84.3246 20.08H81.1131C80.8738 20.08 80.6798 20.2739 80.6798 20.5132V35.2102H84.7579V20.5132C84.7579 20.2739 84.5639 20.08 84.3246 20.08Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7516 35.0369H51.4001",
    stroke: "#4C4D51",
    strokeWidth: 0.1,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1743 53.1436C36.2406 50.0772 36.2405 45.1057 33.1741 42.0395C30.1078 38.9732 25.1363 38.9733 22.07 42.0396C19.0038 45.106 19.0038 50.0775 22.0702 53.1438C25.1366 56.21 30.1081 56.2099 33.1743 53.1436Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7413 52.7106C35.5684 49.8834 35.5683 45.2996 32.7411 42.4725C29.9139 39.6454 25.3302 39.6455 22.503 42.4727C19.6759 45.2999 19.676 49.8836 22.5032 52.7107C25.3304 55.5379 29.9142 55.5378 32.7413 52.7106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.623 47.5918L32.7386 52.344C31.4181 53.7654 29.5632 54.5741 27.623 54.5741C24.9866 54.5741 22.5661 53.081 21.3831 50.7248L27.623 47.5918Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.623 47.5918L30.9688 41.4634C33.2076 42.6856 34.6053 45.0412 34.6053 47.5918C34.6053 49.3493 33.9418 51.0435 32.7483 52.3335L27.623 47.5918Z",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.623 47.5919L21.4149 50.7874C20.9062 49.7991 20.6408 48.7034 20.6408 47.5919C20.6408 43.7615 23.7927 40.6096 27.623 40.6096C28.8233 40.6096 30.0035 40.9191 31.0493 41.5081L27.623 47.5919Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M65.2899 88.3347L56.702 84.1773L47.0103 95.7353L45.383 93.4252L47.4085 77.8881L39.3858 53.7404L21 60.2496L25.8971 72.5776L41.6352 110.464L45.106 119.049L45.5081 116.556L49.3431 101.933L54.703 95.9819L64.2733 95.246L49.0321 84.697L65.2899 88.3347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4848 42.869C56.1705 42.869 60.7796 38.4212 60.7796 32.9345C60.7796 27.4478 56.1705 23 50.4848 23C44.7991 23 40.1899 27.4478 40.1899 32.9345C40.1899 38.4212 44.7991 42.869 50.4848 42.869Z",
    fill: "#0047AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6554 102.715L71.3927 105.86C69.572 102.396 65.7104 100.102 61.3368 100.451C56.2198 100.86 52.1382 104.976 51.9258 109.926C51.8462 111.773 52.2862 113.518 53.1283 115.028L52.7034 115.24L49.3578 116.917L45.1094 119.049C42.9169 114.099 41.062 109.129 39.4954 104.225C39.2412 103.44 38.9947 102.647 38.7595 101.862V101.854C38.585 101.277 38.4105 100.686 38.2777 100.227C38.145 99.7715 38.0539 99.4567 38.0539 99.4567C35.2431 89.6512 33.5248 80.2477 32.493 71.9974L32.5006 72.1568C31.1275 63.1023 31.0592 53.2437 31.0592 53.2437C31.0137 51.605 31.0023 50.1218 31.0023 48.8131C31.0023 48.0204 31.0023 47.2883 31.0175 46.6282C31.0592 44.0033 31.154 42.4519 31.1654 42.2319V42.2053L36.6504 42.9488L39.4195 43.4116C39.4005 43.6543 39.3892 43.9009 39.3892 44.1475C39.3892 49.6363 43.9979 54.082 49.6802 54.082C54.4218 54.082 58.4085 50.9943 59.6033 46.7876L62.5621 47.2807L67.076 48.0735V48.0924C67.0646 48.248 66.9433 50.4632 66.9584 54.0251C66.9584 54.0251 67.2202 64.0696 67.645 67.9463C68.1799 73.4427 69.0826 79.5308 70.6113 85.4824C70.6189 85.5014 70.6227 85.5165 70.6265 85.5355C71.2031 87.8759 71.2827 87.948 71.2865 87.948C72.819 93.2472 74.8825 98.3453 77.6592 102.711L77.6554 102.715Z",
    fill: "#6495ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2651 80.2555C56.4457 74.4295 56.1435 69.6666 53.5421 63.8875C53.1223 62.8745 53.5937 61.5156 53.2078 60.6338C53.1405 60.3718 52.2739 59.7588 51.6412 59.7701C52.7571 57.6532 53.6445 55.4507 52.9526 53.0458C52.2744 52.8609 51.3291 52.7414 50.1431 52.9282C47.5399 53.338 47.1435 54.6836 47.1435 54.6836C47.1435 54.6836 50.0165 59.0128 50.0796 59.2587C50.1427 59.5041 49.4109 63.9428 49.4011 69.6783C49.3913 75.4137 51.4669 85.0829 51.4669 85.0829L57.9912 96.1521L59.9182 86.1719C59.5635 84.8662 59.2027 83.5616 58.865 82.2517C58.7304 81.7281 58.5497 80.7442 58.2651 80.2555Z",
    fill: "#37475B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3452 68.8402C55.1112 64.9425 52.9187 58.7858 52.9187 58.7858L54.1927 53.5818C54.1927 53.5818 53.7633 53.2671 52.9532 53.0461C53.645 55.451 52.1255 57.6647 51.0095 59.7816C51.6418 59.7704 52.2259 60.1876 52.2933 60.45C52.6792 61.3319 52.4666 62.3557 52.8869 63.3686C55.4879 69.1478 56.2261 75.0916 58.045 80.9177C58.3296 81.4064 58.7304 81.7281 58.8652 82.2525C59.2029 83.5624 59.5632 84.8671 59.9184 86.1727L60.7097 82.0732C60.7097 82.0732 57.845 73.577 56.3452 68.8402Z",
    fill: "#2A3849"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessNetworking2);
export default __webpack_public_path__ + "static/media/Business & Networking (2).2126ba4058b46955cb45ebe0f6583c78.svg";
export { ForwardRef as ReactComponent };